import {api} from "./api";
import {slugifyText} from "./utils/string";
import {Notify} from "@/shared/ui/notify";

export function buildCopyEntityLinkIcon(message: string, url: string, successMessage?: string) {
	const successMessageTag = successMessage ? `data-copy-clipboard-success='${successMessage}'` : "";
	return ` <a data-copy-clipboard title='${message}' href='${url}' ${successMessageTag}><i class='fas fa-chain'></i></a>`
}

export function buildCopyTaskIcon(taskId: string, taskBreadCrumbs: string) {
	// DEVNOTE: We use breadcrumbs as the basis for the slug as otherwise we would have to travel up the task hierarchy
	// to get the full path. As a downside we can't replace / that might be contained in task names
	return buildCopyEntityLinkIcon(
		messages["taskLink.copy"],
		getTaskLink(taskId, taskBreadCrumbs),
		messages["taskLink.copied"]
	);
}

export function getTaskLink(taskId: string, taskBreadCrumbs: string): string {
	// DEVNOTE: keep the link structure in sync with TaskLinks.java, which matches task links
	// pasted into task search fields and resolved by the EntityLinksController
	return window.location.origin + "/timr/tasks/" + taskId + "#" + slugifyText(taskBreadCrumbs)
}

export function trackTaskLinkCreated(taskId: string) {
	void api("taskLink/trackCreated")
		.post({
			taskId: taskId
		});
}

export function registerCopyLinkListener() {
	document.addEventListener("click", (event: MouseEvent) => {
		if (event.target instanceof Element) {
			const actualTarget = event.target.closest("a[data-copy-clipboard]");
			if (actualTarget && actualTarget instanceof Element) {
				const url = actualTarget.getAttribute("href");
				const successMessage = actualTarget.getAttribute("data-copy-clipboard-success")

				// Only process on "standard" click, otherwise treat it as normal link
				// This allows for default browser behavior like opening in new tab or opening in new window
				if (!event.ctrlKey && !event.shiftKey && !event.metaKey) {
					event.preventDefault();

					navigator.clipboard.writeText(url).then(
						() => {
							if (successMessage) {
								const tooltipId = actualTarget.getAttribute("aria-describedby");
								console.log(actualTarget, tooltipId);
								if (tooltipId != null) {
									// If a tooltip exists, we show the success message there
									const innerElement = document.getElementById(tooltipId)?.querySelector(".tooltip-inner");
									if (innerElement) {
										innerElement.innerHTML = successMessage;
									}
								} else {
									// Otherwise we show it as a notification
									Notify.success(successMessage);
								}
							}
						},
						() => {
							// Do nothing if browser cannot copy to clipboard
						}
					);
				}

				// We track the click event as task link created independent of the type of click
				if (url.includes("/timr/tasks/")) {
					// Currently only task links are supported
					const taskId = url.split("/timr/tasks/")[1].split("#")[0];
					trackTaskLinkCreated(taskId);
				}
			}
		}
	});
}
